import React, { useEffect, useRef } from 'react';

interface Props {
  rest: number;
  onWeiter: () => void;
  onAbmelden: () => void;
}

/** Warnung 1 Minute vor dem Abmelden wegen Inaktivität. */
export const InaktivitaetsWarnung: React.FC<Props> = ({ rest, onWeiter, onAbmelden }) => {
  const knopf = useRef<HTMLButtonElement>(null);
  useEffect(() => { knopf.current?.focus(); }, []);

  return (
    <div style={{ position: 'fixed', inset: 0, background: 'rgba(15,23,42,.55)', zIndex: 100000, display: 'flex', alignItems: 'center', justifyContent: 'center', padding: 16 }}>
      <div
        role="alertdialog"
        aria-modal="true"
        aria-labelledby="inaktiv-titel"
        aria-describedby="inaktiv-text"
        style={{ background: '#fff', color: '#111827', borderRadius: 12, padding: 24, maxWidth: 420, width: '100%', boxShadow: '0 20px 50px rgba(0,0,0,.3)' }}
      >
        <h2 id="inaktiv-titel" style={{ margin: '0 0 8px', fontSize: 18 }}>Sind Sie noch da?</h2>
        <p id="inaktiv-text" style={{ margin: '0 0 20px', fontSize: 14, lineHeight: 1.5 }}>
          Sie werden wegen Inaktivität in <strong aria-live="polite">{rest}</strong> Sekunden abgemeldet.
        </p>
        <div style={{ display: 'flex', gap: 8, justifyContent: 'flex-end' }}>
          <button type="button" onClick={onAbmelden}
            style={{ background: '#fff', color: '#374151', border: '1px solid #d1d5db', borderRadius: 8, padding: '8px 14px', cursor: 'pointer' }}>
            Jetzt abmelden
          </button>
          <button ref={knopf} type="button" onClick={onWeiter}
            style={{ background: '#2563eb', color: '#fff', border: 'none', borderRadius: 8, padding: '8px 14px', cursor: 'pointer', fontWeight: 600 }}>
            Angemeldet bleiben
          </button>
        </div>
      </div>
    </div>
  );
};
